/**
 * @group Auth
 * @summary User role name constants
 *
 * @remarks
 * Centralises role name strings used for role-based access checks throughout
 * the application. Import from `@shared/constants` instead of using magic strings.
 *
 * @example
 * ```typescript
 * import { ROLE_NAMES } from '@shared/constants';
 *
 * if (sessionData.roles.includes(ROLE_NAMES.DOCTOR)) {
 *   // clinician-only logic
 * }
 * ```
 */
export const ROLE_NAMES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  DOCTOR: 'Doctor',
  PATIENT: 'Patient',
} as const;
